import { render, staticRenderFns } from "./Select2.vue?vue&type=template&id=23851c60&scoped=true"
import script from "./Select2.vue?vue&type=script&lang=js"
export * from "./Select2.vue?vue&type=script&lang=js"
import style0 from "../../../../node_modules/vue-select/dist/vue-select.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23851c60",
  null
  
)

export default component.exports